"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var TutorialPreview_1;
var _a, _b, _c, _d, _e, _f, _g, _h, _j;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TutorialPreview = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const StorageService_1 = __importStar(require("@front/services/StorageService"));
const backendImport_1 = require("@front/backendImport");
const component_1 = require("@front/components/site-menu/component");
const SignalService_1 = __importStar(require("@front/services/SignalService"));
const events_1 = require("@front/event/events");
const PopupService_1 = __importStar(require("@front/services/PopupService"));
const TutorialPreviewTypes_1 = require("./helpers/TutorialPreviewTypes");
const TutorialHelpers_1 = require("./helpers/TutorialHelpers");
const TodoHelpers_1 = require("./helpers/TodoHelpers");
const AccordionHelpers_1 = require("./helpers/AccordionHelpers");
const KnowledgeHelpers_1 = require("./helpers/KnowledgeHelpers");
const ChatHelpers_1 = require("./helpers/ChatHelpers");
const ProgressHelpers_1 = require("./helpers/ProgressHelpers");
const FullscreenHelpers_1 = require("./helpers/FullscreenHelpers");
const CommentHelpers_1 = require("./helpers/CommentHelpers");
const WSService_audio_1 = __importStar(require("@front/services/WSService.audio"));
const StatsHelpers_1 = require("./helpers/StatsHelpers");
//@ts-ignore                
let rwsTemplate = T.html `<div class="tutorial-preview-page" ${(0, fast_element_1.ref)('tutorialArea')}>
    ${(0, fast_element_1.when)(x => x.loading, (0, fast_element_1.html) `
    <app-loader></app-loader>
    `)}

    ${(0, fast_element_1.when)(x => !x.loading && x.tutorial, (0, fast_element_1.html) `
    <div id="trainingContainer" class="card shadow-lg">
        <div class="card-body card-body-main">

            
            <div class="sidebar-list d-none d-lg-flex">
                <div class="side-head">
                    ${(0, fast_element_1.when)(x => x.logo, (0, fast_element_1.html) `<img class="side-logo" src="${x => x.logo}" alt="WebFlex" />`)}
                    <select class="side-course">
                        ${(0, fast_element_1.repeat)(x => x.tutorials || [], (0, fast_element_1.html) `
                        <option ?selected="${(x, c) => c.parent.tutorial && x.id === c.parent.tutorial.id}"
                            value="${x => x.id}">${x => x.name}</option>
                        `)}
                    </select>
                </div>
                <div class="scroll-area">
                    <div class="accordion" id="tutorialAccordion">
                        ${(0, fast_element_1.repeat)(x => x.accordionHeaders || [], (0, fast_element_1.html) `
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="heading-${x => x.id}">
                                <button
                                    class="accordion-button ${(x, c) => c.parent.expandedItems.includes(x.id) ? '' : 'collapsed'}"
                                    type="button" @click="${(x, c) => c.parent.toggleAccordion(x.id)}"
                                    aria-expanded="${(x, c) => c.parent.expandedItems.includes(x.id) ? 'true' : 'false'}"
                                    aria-controls="collapse-${x => x.id}">
                                    ${x => x.title}
                                    <div class="operating-area">
                                    <span class="ng-count" data-group="${x => x.trueId}">${(x, c) => c.parent.getStepProgress(x.trueId).done}/${(x, c) => c.parent.getStepProgress(x.trueId).total}</span>
                                    <i
                                        class="simple-icon-arrow-down ms-auto ${(x, c) => c.parent.expandedItems.includes(x.id) ? 'rotated' : ''}"></i>
                                    </div>
                                </button>
                            </h2>
                            <div id="collapse-${x => x.id}"
                                class="accordion-collapse collapse ${(x, c) => c.parent.expandedItems.includes(x.id) ? 'show' : ''}"
                                aria-labelledby="heading-${x => x.id}">
                                <div class="accordion-body">
                                    ${(0, fast_element_1.when)(x => x.sections && x.sections.length > 0, (0, fast_element_1.html) `
                                    ${(0, fast_element_1.repeat)(x => x.sections, (0, fast_element_1.html) `
                                    <div class="step-item ${(x, c) => c.parentContext.parent.activeSection === x.id ? 'active' : ''}"
                                        @click="${(x, c) => c.parentContext.parent.selectSection(x.id)}">
                                        <i class="simple-icon-arrow-right mr-2"></i>
                                        ${(x, c) => c.index + 1}. ${x => x.title}
                                    </div>
                                    `, { positioning: true })}
                                    `, (0, fast_element_1.html) `
                                    <div class="step-item">
                                        <i class="simple-icon-arrow-right mr-2"></i>
                                        @TODO - ${'tutorial.sectionsPlaceholder'.t()}
                                    </div>
                                    `)}
                                </div>
                            </div>
                        </div>
                        `)}
                    </div>
                </div>
            </div>

            
            <div class="content-area">

                
                <div class="nav-tabs-container">
                    <ul class="nav nav-tabs border-0" role="tablist">
                        <li class="nav-item">
                            <button class="nav-link ${x => x.activeTab === 'training' ? 'active' : ''} fw-bold"
                                @click="${x => x.activeTab = 'training'}" type="button">
                                ${'tutorial.yourTraining'.t()}
                            </button>
                        </li>
                        <li class="nav-item">
                            <button class="nav-link ${x => x.activeTab === 'tasks' ? 'active' : ''} fw-bold"
                                @click="${x => x.activeTab = 'tasks'}" type="button">
                                ${'tutorial.yourTasks'.t()}
                            </button>
                        </li>
                    </ul>
                    <div class="fullscreen-holder">
                        <button 
                            type="button"
                            class="fullscreen-toggle-btn ${x => x.isFullscreen ? 'simple-icon-close' : 'simple-icon-size-fullscreen'}"
                            @click="${x => x.handleFullscreenToggle()}"                            
                        ></button>
                    </div>
                </div>

                <div class="course-progress">
                    <div class="cp-row">
                        <span class="cp-label"><i class="simple-icon-graduation"></i> ${'tutorial.completed'.t()}</span>
                        <span class="cp-value" id="overallValue">${x => x.tutorialProgress.doneItems} / ${x => x.tutorialProgress.allItems} zadań · ${x => x.tutorialProgress.percentage}%</span>
                    </div>
                    <div class="progress">
                        <div class="progress-bar" id="progressBar"
                            style="width:${x => x.tutorialProgress.percentage}%"></div>
                    </div>
                </div>

                <div class="course-motivation" id="courseMotivation">
                    <div class="cm-icon"><i class="simple-icon-flag"></i></div>
                    <div class="cm-text">
                        <div class="cm-title" id="cmTitle">Zaczynamy!</div>
                        <div class="cm-sub" id="cmSub">
                            ${x => 'tutorial.motivation'.t({
    allSections: x.tutorialProgress.allItems,
    allSteps: x.tutorialProgress.allSteps
})}
                        </div>
                    </div>
                    <div class="cm-ring" id="cmRing" style="--p: ${x => x.tutorialProgress.percentage};"><span id="cmRingText">${x => x.tutorialProgress.percentage}%</span></div>
                </div>

                <div class="tab-content view-container">
                    
                    <div class="tab-pane fade ${x => x.activeTab === 'training' ? 'show active' : ''}">
                        <div class="chat-messages">
                            ${(0, fast_element_1.when)(x => { var _a; return (((_a = x.activeSectionData) === null || _a === void 0 ? void 0 : _a.tutorialSectionFiles) || []).length > 0; }, (0, fast_element_1.html) `
                            <div class="section-attachments">
                                ${(0, fast_element_1.repeat)(x => { var _a; return ((_a = x.activeSectionData) === null || _a === void 0 ? void 0 : _a.tutorialSectionFiles) || []; }, (0, fast_element_1.html) `
                                <file-card-zoom
                                    :fileData="${sectionFile => sectionFile.file}"
                                    :miniFileData="${sectionFile => sectionFile.mini || null}"
                                    preview="true"
                                    showDownload="true">
                                </file-card-zoom>
                                `)}
                            </div>
                            `)}
                            <app-chat compact="true" ${(0, fast_element_1.ref)('chatComponent')} typing="true"
                                injectCss="/assets/css/chat-override-flex.css" :knowledge="${x => x.selectedKnowledge}"
                                fullscreen="false"
                                :fullKnowledgeIds="${x => x.fullKnowledgeIds}"
                                :selectedModel="${x => x.selectedModel}" :selectedAvatar="${x => x.selectedAvatar}"
                                :selectedAIProvider="openrouter" :injectedMessages="${x => x.injectedMessages}"
                                :conversationId="${x => { var _a; return (_a = x.selectedConversation) === null || _a === void 0 ? void 0 : _a.id; }}"
                                :activeTutorialSection="${x => { var _a; return (_a = x.activeSectionData) === null || _a === void 0 ? void 0 : _a.id; }}">
                            </app-chat>
                            <p class="text-muted">
                                ${'tutorial.chatDescription'.t()}
                            </p>
                        </div>
                    </div>

                    
                    <div class="tab-pane fade ${x => x.activeTab === 'tasks' ? 'show active' : ''}">
                        <div class="tasks-list">
                            ${(0, fast_element_1.when)(x => !x.loadingTodos && !x.activeTodo, (0, fast_element_1.html) `
                            <div class="alert alert-info">
                                <i class="simple-icon-info me-2"></i>
                                ${'tutorial.noTasks'.t()}
                            </div>
                            `)}

                            ${(0, fast_element_1.when)(x => !x.loadingTodos && x.activeTodo, (0, fast_element_1.html) `
                            
                            ${(0, fast_element_1.when)(x => x.activeTodo.items && x.activeTodo.items.length > 0, (0, fast_element_1.html) `
                            ${(0, fast_element_1.repeat)(x => x.activeTodo.items, (0, fast_element_1.html) `
                            <div class="task-card">
                                <input type="checkbox" class="task-checkbox me-3" :checked="${x => x.done}"
                                    @change="${(x, c) => c.parent.updateTodoItemStatus(x.id)}">
                                <div class="ml-3">
                                    <div class="fw-bold">${x => x.title}</div>
                                </div>
                            </div>
                            `)}
                            `, (0, fast_element_1.html) `
                            <div class="alert alert-warning">
                                <i class="simple-icon-info me-2"></i>
                                ${'tutorial.noTasks'.t()}
                            </div>
                            `)}
                            `)}
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    `)}

    ${(0, fast_element_1.when)(x => !x.loading && !x.tutorial, (0, fast_element_1.html) `
    <div class="alert alert-danger">
        <i class="simple-icon-exclamation me-2"></i>
        ${'tutorial.notFound'.t()}
    </div>
    `)}
</div>
`;
require("./styles/layout.scss");
const styles = T.css `.tutorial-preview-page:fullscreen {
  background: #fff;
  overflow: auto;
}
.tutorial-preview-page #trainingContainer {
  height: calc(100vh - 40px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: none;
  border-radius: 15px;
  transition: all 0.3s ease;
}
.tutorial-preview-page #trainingContainer:fullscreen, .tutorial-preview-page:fullscreen #trainingContainer {
  height: 100vh;
  width: 100vw;
  border-radius: 0;
}
.tutorial-preview-page .card-body-main {
  display: flex;
  flex-direction: row;
  padding: 0;
  height: 100%;
  overflow: hidden;
}
.tutorial-preview-page .sidebar-list {
  background: #fff;
  border-right: 1px solid #dee2e6;
  display: flex;
  flex-direction: column;
  width: 30%;
  min-width: 320px;
  height: calc(100vh - 40px);
}
.tutorial-preview-page .sidebar-header {
  padding: 20px;
  background: #fff;
  border-bottom: 1px solid #dee2e6;
}
.tutorial-preview-page .course-progress .cp-label i {
  margin-right: 5px;
}
.tutorial-preview-page .scroll-area {
  flex-grow: 1;
  overflow-y: auto;
}
.tutorial-preview-page .accordion {
  --bs-accordion-color: var(--bs-body-color);
  --bs-accordion-bg: var(--bs-body-bg);
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: var(--bs-border-color);
  --bs-accordion-border-width: var(--bs-border-width);
  --bs-accordion-border-radius: var(--bs-border-radius);
  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: var(--bs-body-color);
  --bs-accordion-btn-bg: var(--bs-accordion-bg);
  --bs-accordion-btn-focus-border-color: #86b7fe;
  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: var(--bs-primary-text-emphasis);
  --bs-accordion-active-bg: var(--bs-primary-bg-subtle);
}
.tutorial-preview-page .accordion-item {
  border: none;
  border-bottom: 1px solid #dee2e6;
}
.tutorial-preview-page .accordion-header {
  margin-bottom: 0;
}
.tutorial-preview-page .accordion-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  position: relative;
  padding: 15px 20px;
  font-size: 1rem;
  border: none;
  transition: background-color 0.3s ease;
  text-align: left;
  color: inherit;
  background: transparent;
}
.tutorial-preview-page .accordion-button:not(.collapsed) {
  background-color: #e7f1ff;
  color: #0d6efd;
  box-shadow: none;
}
.tutorial-preview-page .accordion-button:focus {
  box-shadow: none;
  border-color: rgba(0, 0, 0, 0.125);
}
.tutorial-preview-page .accordion-button i {
  font-size: 14px;
  color: #6c757d;
  transition: transform 0.2s ease-in-out, color 0.2s ease;
}
.tutorial-preview-page .accordion-button i.rotated {
  transform: rotate(180deg);
}
.tutorial-preview-page .accordion-button:not(.collapsed) i {
  color: #0d6efd;
}
.tutorial-preview-page .accordion-collapse {
  transition: height 0.35s ease;
  overflow: hidden;
}
.tutorial-preview-page .accordion-collapse:not(.show) {
  height: 0;
  display: none;
}
.tutorial-preview-page .accordion-collapse.show {
  height: auto;
  display: block;
}
.tutorial-preview-page .accordion-collapse.collapse {
  display: none;
}
.tutorial-preview-page .accordion-collapse.collapse.show {
  display: block;
}
.tutorial-preview-page .accordion-body {
  padding: 0;
}
.tutorial-preview-page .step-item {
  padding: 12px 15px 12px 45px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 1px solid #f8f9fa;
  display: flex;
  align-items: center;
  color: #495057;
  border-radius: 4px;
  margin: 2px 8px;
}
.tutorial-preview-page .step-item:hover {
  background-color: #f8f9fa;
  color: #0d6efd;
  transform: translateX(2px);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.tutorial-preview-page .step-item.active {
  color: #0d6efd;
  font-weight: 600;
  background-color: #e7f3ff;
  border-left: 4px solid #0d6efd;
  padding-left: 41px;
  box-shadow: 0 2px 6px rgba(13, 110, 253, 0.15);
  border-bottom-color: #b3d7ff;
  animation: pulse-active 0.3s ease-in-out;
}
.tutorial-preview-page .step-item i {
  font-size: 0.85rem;
  opacity: 0.7;
  transition: color 0.2s ease;
}
.tutorial-preview-page .step-item.active i {
  opacity: 1;
  color: #0d6efd;
}
.tutorial-preview-page .step-item:hover:not(.active) i {
  opacity: 0.9;
}
@keyframes pulse-active {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.02);
  }
  100% {
    transform: scale(1);
  }
}
.tutorial-preview-page .accordion-item {
  border: none;
  border-bottom: 1px solid #dee2e6;
}
.tutorial-preview-page .content-area {
  display: flex;
  flex-direction: column;
  background: #fff;
  flex-grow: 1;
  position: relative;
}
.tutorial-preview-page .nav-tabs-container {
  padding: 15px 25px 0 25px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.tutorial-preview-page .step-navigator {
  background: #fff;
  border-bottom: 1px solid #dee2e6;
  padding: 10px 25px 20px 25px;
  z-index: 1000;
}
.tutorial-preview-page .course-progress {
  padding: 12px 20px;
  border-bottom: 1px solid var(--primary-color);
}
.tutorial-preview-page .course-progress .cp-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 10px;
  margin-bottom: 7px;
}
.tutorial-preview-page .course-progress .cp-label {
  font-weight: 700;
  font-size: 0.85rem;
  color: var(--text_color);
}
.tutorial-preview-page .course-progress .cp-label i {
  color: var(--primary-color);
}
.tutorial-preview-page .course-progress .cp-value {
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--primary-color);
  white-space: nowrap;
}
.tutorial-preview-page .course-progress .progress {
  height: 8px;
  background: rgb(85.7254901961%, 53.0980392157%, 82.462745098%);
}
.tutorial-preview-page .course-progress .progress-bar {
  background: var(--primary-color);
  transition: width 0.35s ease;
}
.tutorial-preview-page .view-container {
  flex-grow: 1;
  overflow: hidden;
  background: #f9f9fb;
}
.tutorial-preview-page .tab-content,
.tutorial-preview-page .tab-pane {
  height: 100%;
}
.tutorial-preview-page .tab-pane.active {
  display: flex;
  flex-direction: column;
}
.tutorial-preview-page .chat-messages,
.tutorial-preview-page .tasks-list {
  flex-grow: 1;
  overflow-y: auto;
  padding: 25px;
}
.tutorial-preview-page .task-card {
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 10px;
  padding: 15px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  transition: 0.2s;
}
.tutorial-preview-page .task-card:hover {
  border-color: #0d6efd;
}
.tutorial-preview-page .task-checkbox {
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.tutorial-preview-page ::-webkit-scrollbar {
  width: 6px;
}
.tutorial-preview-page ::-webkit-scrollbar-thumb {
  background: #d1d8dd;
  border-radius: 10px;
}
.tutorial-preview-page .spinner-border {
  width: 3rem;
  height: 3rem;
  color: #0d6efd;
}
@media (max-width: 768px) {
  .tutorial-preview-page #trainingContainer {
    height: auto;
    min-height: calc(100vh - 40px);
  }
  .tutorial-preview-page .sidebar-list {
    width: 100%;
    min-width: auto;
    max-height: 300px;
  }
  .tutorial-preview-page .card-body-main {
    flex-direction: column;
  }
  .tutorial-preview-page .content-area {
    min-height: 500px;
  }
}

.course-motivation {
  display: flex;
  align-items: center;
  gap: 14px;
  margin: 14px 20px 2px;
  padding: 12px 14px;
  border: 1px solid var(--separator-color);
  border-radius: 12px;
  background: linear-gradient(90deg, var(--primary-color), #fff 72%);
}

.course-motivation.is-complete {
  background: linear-gradient(90deg, #e2f4ea, #fff 72%);
  border-color: #bfe6cf;
}

.course-motivation .cm-icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  background: #fff;
  border: 1px solid var(--separator-color);
  color: var(--brand);
  font-size: 1.15rem;
}

.course-motivation.is-complete .cm-icon {
  color: var(--wf-green);
  border-color: #bfe6cf;
}

.course-motivation .cm-text {
  flex: 1;
  min-width: 0;
}

.course-motivation .cm-title {
  font-weight: 700;
  font-size: 0.92rem;
  color: var(--ink);
}

.course-motivation .cm-sub {
  font-size: 0.82rem;
  color: var(--muted);
  margin-top: 1px;
}

.course-motivation .cm-ring {
  position: relative;
  flex-shrink: 0;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: conic-gradient(var(--primary-color) calc(var(--p, 0) * 1%), #B874B2 0);
}

.course-motivation.is-complete .cm-ring {
  background: conic-gradient(var(--success) calc(var(--p, 0) * 1%), #e2f4ea 0);
}

.course-motivation .cm-ring::after {
  content: "";
  position: absolute;
  inset: 4px;
  background: #fff;
  border-radius: 50%;
}

.course-motivation .cm-ring span {
  position: relative;
  z-index: 1;
  font-size: 0.72rem;
  font-weight: 800;
  color: var(--primary-color);
}

.course-motivation.is-complete .cm-ring span {
  color: var(--success);
}

.ng-count {
  margin-left: auto;
  padding-left: 8px;
  flex-shrink: 0;
  font-size: 0.72rem;
  font-weight: 700;
  color: var(--muted);
  margin-right: 8px;
}

.fullscreen-toggle-btn {
  margin-left: auto;
  margin-bottom: 6px;
  width: 34px;
  height: 34px;
  border: 1px solid #e9ecef;
  background: #fff;
  color: var(--primary-color);
  border-radius: 8px;
  box-shadow: none;
}
.fullscreen-toggle-btn:hover {
  background-color: var(--primary-color);
  color: #FFF;
}`;
const shadowOptions = { "mode": "open" };
let TutorialPreview = TutorialPreview_1 = class TutorialPreview extends client_1.RWSViewComponent {
    constructor(apiService, notifyService, signalService, popupService, storageService, wsService) {
        super();
        this.apiService = apiService;
        this.notifyService = notifyService;
        this.signalService = signalService;
        this.popupService = popupService;
        this.storageService = storageService;
        this.wsService = wsService;
        this.webflex = true;
        this.loading = false;
        this.isFullscreen = false;
        this.tutorial = null;
        this.activeTab = 'training';
        this.logo = null;
        this.accordionHeaders = [];
        this.expandedItems = [];
        this.activeSection = '';
        this.flatSections = [];
        this.selectedSection = null;
        this.totalSections = 0;
        this.currentSectionIndex = 0;
        this.activeTodo = null;
        this.todoProgress = 0;
        this.loadingTodos = false;
        // Conversation and chat properties
        this.selectedConversation = null;
        this.selectedKnowledge = [];
        this.fullKnowledgeIds = [];
        this.injectedMessages = [];
        this.tutorials = [];
        this.chatInit = false;
        this.participantUuid = '';
        this.statsInterval = null;
        this.lastTodoCommentIndex = -1;
        this.appChatSignal = null;
        this.signalSubscriptions = [];
        this.handleFullscreenChange = () => {
            this.isFullscreen = !!document.fullscreenElement;
        };
    }
    async connectedCallback() {
        super.connectedCallback();
        if (!this.tutorialId) {
            this.tutorialId = this.routeParams.id;
        }
        document.addEventListener('fullscreenchange', this.handleFullscreenChange);
        // Initialize signals and event handling
        this.setupSignals();
        this.setupEventHandlers();
        this.appChatSignal = this.signalService.getSignal('app-chat-signal', { initialValue: null });
        this.on('chat-component-connected', async (event) => {
            this.chatInit = true;
            this.chatComponent = event.detail.chatComponent || this.$('app-chat');
            // Set up model and avatar now that chat component is ready
            this.setupChatModelAndAvatar();
            // Check participant progress before sending the first AI message
            await this.loadParticipantProgress();
            await this.startChatMessage();
        });
        this.on('chat:tool:detected', async (event) => {
            if (event.detail.tool.name === 'detectTasks') {
                const taskIds = event.detail.tool.data.tasks.filter(task => {
                    const isActiveToolTask = this.activeTodo.items.find(activeItem => activeItem.id === task.id && activeItem.done !== task.done);
                    return isActiveToolTask;
                }).map(task => task.id);
                await this.updateMultipleTodoItemStatus(taskIds);
            }
        });
        await this.loadTutorial();
        await Promise.all([
            this.loadActiveTodo(),
            this.loadData()
        ]);
        if (this.webflex) {
        }
        // Give the template time to render the chat component, then setup model/avatar
        setTimeout(() => {
            this.setupChatModelAndAvatar();
        }, 100);
    }
    async loadData() {
        try {
            this.loading = true;
            const response = await this.apiService.back.get('tutorial.list', { queryParams: { all: '1' } });
            if (response && response.success && Array.isArray(response.data)) {
                this.tutorials = response.data;
            }
            else {
                this.popupService.error((response === null || response === void 0 ? void 0 : response.error) || 'tutorial.loadListFailed'.t());
            }
        }
        catch (error) {
            console.error('Failed to load tutorials:', error);
            this.popupService.error('tutorial.loadListFailed'.t());
        }
        finally {
            this.loading = false;
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener('fullscreenchange', this.handleFullscreenChange);
        this.appChatSignal.setValue({ command: 'stop-talk' });
        this.appChatSignal.setValue({ command: 'stop-chat' });
        this.appChatSignal.setValue(null);
        // Clean up signal subscriptions
        this.signalSubscriptions.forEach((sub) => {
            if (!sub.closed) {
                sub.unsubscribe();
            }
        });
        this.signalSubscriptions = [];
        clearInterval(this.statsInterval);
        this.statsInterval = null;
    }
    async tutorialIdChanged() {
        // if (this.tutorialId && this.apiService) {            
        //     await this.loadTutorial();
        //     await this.loadActiveTodo();
        // }
    }
    async loadTutorial() {
        try {
            if (!this.tutorial) {
                this.loading = true;
            }
            const routeOptions = {
                routeParams: { id: this.tutorialId }
            };
            if (this.participantUuid) {
                routeOptions.queryParams = { participantUuid: this.participantUuid };
            }
            const response = await this.apiService.back.get('tutorial.get', routeOptions);
            if (response.success && response.data) {
                this.tutorial = response.data;
                this.setupAccordionHeaders();
                this.loadSectionKnowledge();
                // Set the model and avatar for the chat component after tutorial loads
                this.setupChatModelAndAvatar();
                // Use the avatar's voice if no voice has been selected yet
                this.setDefaultVoiceFromAvatar();
            }
            else {
                this.notifyService.notify('tutorial.loadFailed'.t(), 'error');
            }
        }
        catch (error) {
            console.error('Failed to load tutorial:', error);
            this.notifyService.notify('tutorial.loadFailed'.t(), 'error');
        }
        finally {
            this.loading = false;
        }
    }
    setDefaultVoiceFromAvatar() {
        var _a, _b, _c;
        const savedVoice = this.storageService.get('tutorial_audio_voice');
        if (savedVoice) {
            return;
        }
        const avatarVoice = (_b = (_a = this.tutorial) === null || _a === void 0 ? void 0 : _a.avatar) === null || _b === void 0 ? void 0 : _b.voice;
        if (!avatarVoice) {
            return;
        }
        this.storageService.set('tutorial_audio_voice', avatarVoice, 'local');
        (_c = this.appChatSignal) === null || _c === void 0 ? void 0 : _c.setValue({ command: 'setup-chat', params: { voice: avatarVoice } });
    }
    setupAccordionHeaders() {
        var _a;
        if (!((_a = this.tutorial) === null || _a === void 0 ? void 0 : _a.tutorialSteps)) {
            return;
        }
        this.flatSections = TutorialHelpers_1.TutorialHelpers.flattenSections(this.tutorial);
        this.totalSections = this.flatSections.length;
        if (this.flatSections.length > 0 && !this.activeSection) {
            this.activeSection = this.flatSections[0].id;
            this.currentSectionIndex = 0;
        }
        else if (this.activeSection) {
            const currentSection = TutorialHelpers_1.TutorialHelpers.findSectionById(this.flatSections, this.activeSection);
            if (currentSection) {
                this.currentSectionIndex = currentSection.sectionIndex;
            }
        }
        const { headers, newExpandedItems } = AccordionHelpers_1.AccordionHelpers.buildAccordionHeaders(this.tutorial, this.flatSections, this.expandedItems);
        this.accordionHeaders = headers;
        this.expandedItems = newExpandedItems;
    }
    editTutorial() {
        component_1.SiteMenu.goto.bind(this)(`/tutorial/edit/${this.tutorialId}`);
    }
    backToList() {
        component_1.SiteMenu.goto.bind(this)('/tutorial/list');
    }
    // Section navigation methods
    async selectSection(sectionId, dontSend) {
        var _a, _b, _c, _d;
        const section = TutorialHelpers_1.TutorialHelpers.findSectionById(this.flatSections, sectionId);
        if (section) {
            this.activeSection = section.id; // Always use the flattened section ID for activeSection
            this.selectedSection = section;
            this.currentSectionIndex = section.sectionIndex;
            const talkingValue = this.appChatSignal.getValue();
            if (talkingValue && ['start-talk', 'setup-chat', 'pause-talk', 'resume-talk', 'start-write'].includes(talkingValue.command)) {
                this.appChatSignal.setValue({ command: 'stop-talk' });
            }
            if (talkingValue) {
                this.appChatSignal.setValue({ command: 'stop-chat' });
            }
            // Immediately reset active todo to ensure clean state
            this.activeTodo = null;
            this.todoProgress = 0;
            // Load todos for the new active section
            this.loadActiveTodo();
            // Load knowledge for the new active section
            this.loadSectionKnowledge();
            const step = (_b = (_a = this.tutorial) === null || _a === void 0 ? void 0 : _a.tutorialSteps) === null || _b === void 0 ? void 0 : _b[section.stepIndex];
            if (this.participantUuid && (step === null || step === void 0 ? void 0 : step.id) && section.sectionId) {
                await this.saveParticipantProgress(section.sectionId, step.id);
            }
            if (this.tutorial.source !== 'file' && !dontSend) {
                // Save participant progress before sending AI chat message              
                (_c = this.chatComponent) === null || _c === void 0 ? void 0 : _c.appendInputTextToChat('tutorial.new-section.prompt'.t() + ' ' + ((_d = this.activeSectionData) === null || _d === void 0 ? void 0 : _d.title), true, true);
            }
            else if (this.tutorial.source === 'file' && !dontSend) {
                ChatHelpers_1.ChatHelpers.getFileSectionContent.bind(this)(section.sectionId);
            }
            StatsHelpers_1.StatsHelpers.monitorSectionTime.bind(this)(section.sectionId);
        }
    }
    getSectionsForStep(stepIndex) {
        return TutorialHelpers_1.TutorialHelpers.getSectionsForStep(this.flatSections, stepIndex);
    }
    getStepProgress(stepId) {
        var _a, _b, _c, _d, _e;
        const progress = (_c = (_b = (_a = this.tutorial) === null || _a === void 0 ? void 0 : _a._progress) === null || _b === void 0 ? void 0 : _b.donePerStep) === null || _c === void 0 ? void 0 : _c[stepId];
        return { done: (_d = progress === null || progress === void 0 ? void 0 : progress.done) !== null && _d !== void 0 ? _d : 0, total: (_e = progress === null || progress === void 0 ? void 0 : progress.max) !== null && _e !== void 0 ? _e : 0 };
    }
    get progressPercentage() {
        return TodoHelpers_1.TodoHelpers.calculateTodoProgress(this.activeTodo);
    }
    get tutorialProgress() {
        var _a, _b, _c, _d, _e, _f, _g;
        const progress = (_a = this.tutorial) === null || _a === void 0 ? void 0 : _a._progress;
        return {
            doneSections: (_b = progress === null || progress === void 0 ? void 0 : progress.doneSections) !== null && _b !== void 0 ? _b : 0,
            allSections: (_c = progress === null || progress === void 0 ? void 0 : progress.allSections) !== null && _c !== void 0 ? _c : 0,
            allSteps: (_d = progress === null || progress === void 0 ? void 0 : progress.allSteps) !== null && _d !== void 0 ? _d : 0,
            doneItems: (_e = progress === null || progress === void 0 ? void 0 : progress.doneItems) !== null && _e !== void 0 ? _e : 0,
            allItems: (_f = progress === null || progress === void 0 ? void 0 : progress.allItems) !== null && _f !== void 0 ? _f : 0,
            percentage: (_g = progress === null || progress === void 0 ? void 0 : progress.percentage) !== null && _g !== void 0 ? _g : 0
        };
    }
    get currentSectionNumber() {
        return this.currentSectionIndex + 1;
    }
    // Custom accordion methods
    toggleAccordion(itemId) {
        this.expandedItems = AccordionHelpers_1.AccordionHelpers.toggleAccordion(this.expandedItems, itemId);
    }
    // Todo management methods
    async loadActiveTodo() {
        var _a, _b;
        if (!this.tutorialId || !this.tutorial) {
            this.activeTodo = null;
            this.calculateTodoProgress();
            return;
        }
        try {
            this.loadingTodos = true;
            // Reset active todo first
            this.activeTodo = null;
            this.todoProgress = 0;
            // Get the todo from the active section
            const { section } = TutorialHelpers_1.TutorialHelpers.findStepAndSection(this.tutorial, this.flatSections, this.activeSection);
            // Only set activeTodo if section has todos
            if (section && section.tutorialSectionTodos && section.tutorialSectionTodos.length > 0) {
                this.activeTodo = section.tutorialSectionTodos[0].todo;
                console.log('[TutorialPreview] loaded activeTodo:', this.activeTodo);
                console.log('[TutorialPreview] activeTodo.items:', (_b = (_a = this.activeTodo) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.map(i => ({ id: i.id, title: i.title, done: i.done })));
            }
            // activeTodo remains null if no todos found
            this.calculateTodoProgress();
        }
        catch (error) {
            console.error('Error loading todos:', error);
            this.notifyService.notify('Failed to load todos', 'error');
            this.activeTodo = null;
            this.todoProgress = 0;
        }
        finally {
            this.loadingTodos = false;
        }
    }
    calculateTodoProgress() {
        this.todoProgress = TodoHelpers_1.TodoHelpers.calculateTodoProgress(this.activeTodo);
    }
    async updateTodoItemStatus(todoItemId) {
        var _a;
        try {
            // Send PUT request to toggle todo item status
            const response = await this.apiService.back.put('todo-item.update', { itemId: todoItemId, participantUuid: this.participantUuid });
            if (response && response.success) {
                // Reload tutorial and todo data from server (don't manually toggle)
                await this.loadTutorial();
                await this.loadActiveTodo();
                const theItem = this.activeTodo.items.find(item => item.id === todoItemId);
                if (theItem) {
                    (_a = this.chatComponent) === null || _a === void 0 ? void 0 : _a.addSimulatedAIMessage(this.pickTodoChangeComment(theItem.title, !!theItem.done));
                }
                this.notifyService.notify('Todo item status updated');
            }
            else {
                this.notifyService.notify('Failed to update todo item status', 'error');
            }
        }
        catch (error) {
            console.error('Error updating todo item status:', error);
            this.notifyService.notify('Failed to update todo item status', 'error');
        }
    }
    pickTodoChangeComment(itemName, done) {
        const { comment, newLastIndex } = CommentHelpers_1.CommentHelpers.pickTodoChangeComment(itemName, done, this.lastTodoCommentIndex, TutorialPreview_1.TODO_CHANGE_COMMENT_KEYS);
        this.lastTodoCommentIndex = newLastIndex;
        return comment;
    }
    async updateMultipleTodoItemStatus(todoItemIds) {
        try {
            // Update all todo items
            const updatePromises = todoItemIds.map(id => this.apiService.back.put('todo-item.update', { itemId: id, participantUuid: this.participantUuid }));
            const results = await Promise.all(updatePromises);
            const successCount = results.filter(response => response && response.success).length;
            if (successCount > 0) {
                // Reload tutorial and todo data once after all updates
                await this.loadTutorial();
                await this.loadActiveTodo();
                this.notifyService.notify(`${successCount} todo item${successCount > 1 ? 's' : ''} updated`);
            }
            if (successCount < todoItemIds.length) {
                this.notifyService.notify('Some todo items failed to update', 'error');
            }
        }
        catch (error) {
            console.error('Error updating todo items:', error);
            this.notifyService.notify('Failed to update todo items', 'error');
        }
    }
    async updateTodoStatus(todoId, done) {
        try {
            // Send PUT request to update todo status
            const response = await this.apiService.back.put('todo.update', { done }, {
                routeParams: { id: todoId.toString() }
            });
            if (response && response.success) {
                // Update local todo status
                if (this.activeTodo && this.activeTodo.id === todoId) {
                    this.activeTodo.done = done;
                    this.activeTodo = { ...this.activeTodo }; // Trigger reactivity
                    this.calculateTodoProgress();
                }
                this.notifyService.notify(done ? 'Todo marked as completed' : 'Todo marked as incomplete');
            }
            else {
                this.notifyService.notify('Failed to update todo status', 'error');
            }
        }
        catch (error) {
            console.error('Error updating todo status:', error);
            this.notifyService.notify('Failed to update todo status', 'error');
        }
    }
    get completedTodosCount() {
        return TodoHelpers_1.TodoHelpers.completedTodosCount(this.activeTodo);
    }
    get totalTodosCount() {
        return TodoHelpers_1.TodoHelpers.totalTodosCount(this.activeTodo);
    }
    get activeSectionData() {
        const { section } = TutorialHelpers_1.TutorialHelpers.findStepAndSection(this.tutorial, this.flatSections, this.activeSection);
        return section;
    } // Auto-progression metho
    async loadParticipantProgress() {
        try {
            const response = await this.apiService.back.get('tutorial.participant.progress', {
                routeParams: { id: this.tutorialId }
            });
            if (response.success && response.data) {
                this.participantUuid = response.data.participant.uuid;
                const flatSection = ProgressHelpers_1.ProgressHelpers.findFlatSectionByProgress(this.flatSections, response.data.section);
                if (flatSection) {
                    this.selectSection(flatSection.id, this.tutorial.source === 'ai');
                    await this.loadActiveTodo();
                }
            }
        }
        catch (error) {
            console.error('Failed to load participant progress:', error);
        }
    }
    // Signal and event handling methods
    setupSignals() {
        // Get or create the conversation signal
        this.conversationSignal = this.signalService.getSignal('selected_conversation', { initialValue: null });
        // Subscribe to conversation changes
        this.signalSubscriptions.push(this.conversationSignal.value$.subscribe(conversation => {
            this.handleConversationChange((conversation === null || conversation === void 0 ? void 0 : conversation.conversation) || null, (conversation === null || conversation === void 0 ? void 0 : conversation.frontMessages) || []);
        }));
    }
    setupEventHandlers() {
        // Listen for conversation start events
        this.on(events_1.appEvents.frontChatConversationStart, (event) => {
            const { conversationId } = event.detail;
            if (conversationId) {
                this.getConvo(conversationId);
            }
        });
        // Listen for conversation end events
        this.on(events_1.appEvents.frontChatConversationEnd, (event) => {
            this.conversationSignal.setValue(null);
        });
        // Listen for message injection events
        this.on(events_1.appEvents.injectMessages, async (event) => {
            const { conversation, messages } = event.detail;
            this.injectedMessages = messages;
            // Update conversation through signal
            this.conversationSignal.setValue({ conversation: conversation, frontMessages: messages, isNew: false });
        });
    }
    /**
     * Handle conversation changes from signal
     */
    handleConversationChange(conversation, frontMessages) {
        this.selectedConversation = conversation;
        if (conversation === null) {
            this.injectedMessages = [];
        }
    }
    /**
     * Load conversation data from API
     */
    async getConvo(id) {
        try {
            const response = await this.apiService.back.get('conversation.get', { routeParams: { id } });
            if (response && response.success && response.data) {
                const convo = response.data;
                this.conversationSignal.setValue({ conversation: convo, frontMessages: [], isNew: true });
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'chat.failedToLoadConversation'.t(), 'error');
            }
        }
        catch (error) {
            this.notifyService.notify('chat.failedToLoadConversation'.t(), 'error');
        }
    }
    get selectedAvatar() {
        var _a;
        if ((_a = this.tutorial) === null || _a === void 0 ? void 0 : _a.avatar) {
            return this.tutorial.avatar;
        }
        return null;
    }
    /**
     * Load knowledge bound to the current active section
     */
    loadSectionKnowledge() {
        const { selectedKnowledge, fullKnowledgeIds } = KnowledgeHelpers_1.KnowledgeHelpers.extractKnowledgeIds(this.activeSectionData);
        this.selectedKnowledge = selectedKnowledge;
        this.fullKnowledgeIds = fullKnowledgeIds;
    }
    get selectedModel() {
        var _a;
        return ChatHelpers_1.ChatHelpers.buildSelectedModel(((_a = this.tutorial) === null || _a === void 0 ? void 0 : _a.avatar) || null);
    }
    /**
     * Setup chat model and avatar when tutorial loads
     */
    setupChatModelAndAvatar() {
        // Use the ref to get the chat component
        this.chatComponent = this.chatComponent || this.chatComponent;
        if (!this.chatComponent) {
            return;
        }
        const model = this.selectedModel;
        const avatar = this.selectedAvatar;
        if (model && this.chatComponent.setModelData) {
            // Use the ChatComponent's setModelData method to properly set the model
            this.chatComponent.setModelData(model);
        }
    }
    async saveParticipantProgress(sectionId, stepId) {
        try {
            await this.apiService.back.post('tutorial.participant.progress.save', { participantUuid: this.participantUuid, sectionId, stepId }, { routeParams: { id: this.tutorialId } });
        }
        catch (error) {
            console.error('Failed to save participant progress:', error);
        }
    }
    async startChatMessage() {
        var _a;
        if (this.tutorial.source === 'ai') {
            const theStartPrompt = ChatHelpers_1.ChatHelpers.buildStartPrompt(this.currentSectionIndex, this.selectedSection);
            console.log('chatcomponentmessage', this.chatComponent);
            (_a = this.chatComponent) === null || _a === void 0 ? void 0 : _a.appendInputTextToChat(theStartPrompt, true, true);
        }
    }
    async handleFullscreenToggle() {
        try {
            await FullscreenHelpers_1.FullscreenHelpers.toggleFullscreen(this.tutorialArea, this.isFullscreen);
        }
        catch (error) {
            console.error('Failed to toggle fullscreen:', error);
        }
    }
};
exports.TutorialPreview = TutorialPreview;
TutorialPreview.TODO_CHANGE_COMMENT_KEYS = [
    'tutorial.todos.changeComment.1',
    'tutorial.todos.changeComment.2',
    'tutorial.todos.changeComment.3',
    'tutorial.todos.changeComment.4',
];
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Object)
], TutorialPreview.prototype, "webflex", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], TutorialPreview.prototype, "tutorialId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], TutorialPreview.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], TutorialPreview.prototype, "isFullscreen", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], TutorialPreview.prototype, "tutorial", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], TutorialPreview.prototype, "activeTab", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], TutorialPreview.prototype, "logo", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TutorialPreview.prototype, "accordionHeaders", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TutorialPreview.prototype, "expandedItems", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], TutorialPreview.prototype, "activeSection", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TutorialPreview.prototype, "flatSections", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_g = typeof TutorialPreviewTypes_1.IFlatSection !== "undefined" && TutorialPreviewTypes_1.IFlatSection) === "function" ? _g : Object)
], TutorialPreview.prototype, "selectedSection", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], TutorialPreview.prototype, "totalSections", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], TutorialPreview.prototype, "currentSectionIndex", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_h = typeof backendImport_1.ITodo !== "undefined" && backendImport_1.ITodo) === "function" ? _h : Object)
], TutorialPreview.prototype, "activeTodo", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], TutorialPreview.prototype, "todoProgress", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], TutorialPreview.prototype, "loadingTodos", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_j = typeof backendImport_1.IConversation !== "undefined" && backendImport_1.IConversation) === "function" ? _j : Object)
], TutorialPreview.prototype, "selectedConversation", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TutorialPreview.prototype, "selectedKnowledge", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TutorialPreview.prototype, "fullKnowledgeIds", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TutorialPreview.prototype, "injectedMessages", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TutorialPreview.prototype, "tutorials", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], TutorialPreview.prototype, "chatInit", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], TutorialPreview.prototype, "participantUuid", void 0);
exports.TutorialPreview = TutorialPreview = TutorialPreview_1 = __decorate([
    (0, client_1.RWSView)('tutorial-preview', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(client_1.ApiService)),
    __param(1, (0, client_1.RWSInject)(client_1.NotifyService)),
    __param(2, (0, client_1.RWSInject)(SignalService_1.default)),
    __param(3, (0, client_1.RWSInject)(PopupService_1.default)),
    __param(4, (0, client_1.RWSInject)(StorageService_1.default)),
    __param(5, (0, client_1.RWSInject)(WSService_audio_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof client_1.ApiServiceInstance !== "undefined" && client_1.ApiServiceInstance) === "function" ? _a : Object, typeof (_b = typeof client_1.NotifyServiceInstance !== "undefined" && client_1.NotifyServiceInstance) === "function" ? _b : Object, typeof (_c = typeof SignalService_1.SignalServiceInstance !== "undefined" && SignalService_1.SignalServiceInstance) === "function" ? _c : Object, typeof (_d = typeof PopupService_1.PopupServiceInstance !== "undefined" && PopupService_1.PopupServiceInstance) === "function" ? _d : Object, typeof (_e = typeof StorageService_1.StorageServiceInstance !== "undefined" && StorageService_1.StorageServiceInstance) === "function" ? _e : Object, typeof (_f = typeof WSService_audio_1.WSServiceAudioInstance !== "undefined" && WSService_audio_1.WSServiceAudioInstance) === "function" ? _f : Object])
], TutorialPreview);
TutorialPreview.defineComponent();
